import React from 'react';
import cls from 'classnames';

import pizzaImg from 'images/pizza-bites.gif';
import pizzaImg2x from 'images/pizza-bites@2x.gif';

import styles from './index.module.sass';

interface PizzaLoaderProps {
  className?: string;
}

export const PizzaLoader = ({ className }: PizzaLoaderProps ) => (
  <img
    alt="Loading..."
    className={cls( styles.pizza, className )}
    src={pizzaImg}
    srcSet={`${pizzaImg2x} 2x`}
  />
);
